// extracted by mini-css-extract-plugin
export default {"whiteList":"WhiteList_whiteList__ltoe-","infoWrapper":"WhiteList_infoWrapper__prG4f"};